import {AvailableCurrencyComponent} from './available-currency';
import {BadgeComponent} from './badge';
import {EditableCellComponent} from './editable-cell';
import {EditButtonGroupComponent} from './edit-button-group';
import {PANEL_DETAILS_COMPONENTS} from './panel-details';
import {ProfileKindBadgeComponent} from './profile.kind.badge.component';
import {ProfileStateBadgeComponent} from './profile.state.badge.component';
import {FourStopProcessingBadgeComponent} from './fourstop.state.badge.component';
import {ProfileTypeImageComponent} from './profile.type.icon.component';
import {WhitelabelBadgeComponent} from './whitelabel.badge.component';
import {ProfileAccountsComponent} from './accounts/profile.accounts.component';
import {ProfileCardsComponent} from './cards/profile.cards.component';
import {ProfileCardComponent} from './cards/card/card.component';
import {FileUploadModalComponent} from './file.upload.modal/file.upload.modal.component';
import {KYC_VERIFICATION_COMPONENTS} from './kyc';
import {KYC_VERIFICATION_RESULTS_COMPONENTS} from './kyc/results';
import {ONFIDO_VERIFICATION_COMPONENTS} from './onfido';
import {ONFIDO_VERIFICATION_RESULTS_COMPONENTS} from './onfido/results';
import {ARIADNEXT_VERIFICATION_COMPONENTS} from './ariadnext';
import {CORPORATE_PROFILE_DOCUMENTS_COMPONENTS} from './profile-details/documents';
import {EmailSendComponent} from './emails';
import {BusinessCustomersInformationComponent} from "./business.customer.information";
import {OfficialBusinessLocationComponent} from "./official-business-location";
import {ProfileUsersComponent} from "./users/profile.users.component";
import {ProfileApiAccessComponent} from "./api-access/profile.api-access.component";
import {ConverterStringToDateString} from "./pipes/date.converter.pipe";
import {ProfileProviderBadgeComponent} from "./profile-provider-badge.component";

export const PROFILE_SHARED_COMPONENTS = [
    ProfileKindBadgeComponent,
    ProfileStateBadgeComponent,
    ProfileProviderBadgeComponent,
    ProfileTypeImageComponent,
    FourStopProcessingBadgeComponent,
    WhitelabelBadgeComponent,
    ProfileAccountsComponent,
    ProfileUsersComponent,
    ProfileApiAccessComponent,
    ConverterStringToDateString,
    ProfileCardsComponent,
    ProfileCardComponent,
    FileUploadModalComponent,
    EditButtonGroupComponent,
    EditableCellComponent,
    AvailableCurrencyComponent,
    BadgeComponent,
    EmailSendComponent,
    BusinessCustomersInformationComponent,
    OfficialBusinessLocationComponent,
    ...KYC_VERIFICATION_COMPONENTS,
    ...KYC_VERIFICATION_RESULTS_COMPONENTS,
    ...ONFIDO_VERIFICATION_COMPONENTS,
    ...ONFIDO_VERIFICATION_RESULTS_COMPONENTS,
    ...ARIADNEXT_VERIFICATION_COMPONENTS,
    ...PANEL_DETAILS_COMPONENTS,
    ...CORPORATE_PROFILE_DOCUMENTS_COMPONENTS
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/index.ts